var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.883 1.28577C9.64292 1.28577 8.57948 2.17086 8.35434 3.39036L3.13236 31.6761C2.84059 33.2565 4.05391 34.7143 5.66106 34.7143H30.339C31.9461 34.7143 33.1595 33.2565 32.8677 31.6761L27.6457 3.39036C27.4206 2.17085 26.3571 1.28577 25.117 1.28577H10.883ZM18 24.4286C17.2899 24.4286 16.7143 25.0043 16.7143 25.7143V29.5715C16.7143 30.2816 17.2899 30.8572 18 30.8572C18.7101 30.8572 19.2857 30.2816 19.2857 29.5715V25.7143C19.2857 25.0043 18.7101 24.4286 18 24.4286ZM16.7143 15.4286C16.7143 14.7185 17.2899 14.1429 18 14.1429C18.7101 14.1429 19.2857 14.7185 19.2857 15.4286V18.0001C19.2857 18.7101 18.7101 19.2858 18 19.2858C17.2899 19.2858 16.7143 18.7101 16.7143 18.0001V15.4286ZM18 5.14291C17.2899 5.14291 16.7143 5.71854 16.7143 6.42862V9.00005C16.7143 9.71013 17.2899 10.2858 18 10.2858C18.7101 10.2858 19.2857 9.71013 19.2857 9.00005V6.42862C19.2857 5.71854 18.7101 5.14291 18 5.14291Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.2fd0f3eede050f492ee0eb6e02c23869.svg";
export { ForwardRef as ReactComponent };